export enum ButtonState {
  disabled,
  inactive,
  excluded,
  included,
  fullTextCannotBeRetrieved,
  duplicate,
  appraised,
  aiSuggestedInclusion,
  aiSuggestedExclusion,
}

export enum SnackbarState {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum StudyState {
  DUPLICATE = "Duplicate",
  UNSCREENED = "Unscreened",
  INCLUDED = "Included",
  EXCLUDED = "Excluded",
  FAVOURITE = "Favorite",
  QUARANTINED = "QUARANTINED",
}

export enum SortBy {
  None,
  Title,
  Author,
  Year,
}

export enum SortOrder {
  Ascending,
  Descending,
}
